/*获取字典表的通用数据工具*/
import api_common from "../../../../api/api_common";
import Vue from "vue";

/*根据字典key获取字典内容*/
let get_value_by_key = function (dic_key){
  let value = key_value[dic_key]
  return value || ""
}

/*根据字典key获取格式化后的字典内容*/
let get_formate_value_by_key = function (dic_key){
  let value = key_value[dic_key]
  return value ? {
    code:200,
    data:JSON.parse(JSON.stringify(value)),
    msg:'操作成功'
  } : {
    code:200,
    data:[],
    msg:'操作成功'
  }
}


/*根据key获取对应字典的文字*/
let get_name_by_key_new = (row,key,dic_code) => {
  if(!row[key]){
    row[key+ '_name'] =  ''
    return
  }

  //方案一：本想直接用这个方式直接return出去，但是这里异步调用接口  事件循环机制导致界面不能及时显示  无果而终
  //方案二（如下）：新增一个字段   先把这个字段变成响应式  然后赋值  页面响应式回显
  if(!row.hasOwnProperty(key+'_name')){
    Vue.set(row,key+ '_name','')
  }

  get_dictionaries(dic_code).then(res =>{
    let item = res.data.find(item => {return item.dicNumber == row[key]})
    if(item){
      row[key+ '_name'] = item.dicName || ''
    }

  })

}

/**
 * 查询字典表
 * @param dic_key 字典key
 * @returns {Promise<void>}
 */
let get_dictionaries = async function (dic_key,options = {} ) {
  return new Promise((resolve,reject) =>{
    /*query_dic(dic_key,options,resolve,reject)*/
    let cur_value =  get_value_by_key(dic_key);
    if(cur_value){
      resolve(get_formate_value_by_key(dic_key))
    }else{
      query_dic(dic_key,options,resolve,reject)
    }
  });
}

/*存储已经查询过的字典*/
let key_value = {};

/*从接口查询字典*/
let query_dic = async function(dic_key,options,resolve,reject){
  try {
    let res;
    res = await api_common.getDictionariesByDicnameNew({categoryNumber:dic_key})

    if (res.code == 0) {
      res.data.list = res.data.list || []

      /*这里将结果转换成前端需要的格式*/
      let finale_res = []
      res.data.list.forEach(item => {
        finale_res.push(item)
      })

      /*给每条数据加一个vlaue_key唯一属性*/
      finale_res.forEach((item,index) =>{
        item.vlaue_key = index
      })
      key_value[dic_key] = finale_res

      resolve(get_formate_value_by_key(dic_key))
    } else {
      resolve(res)
      console.log("字典接口code!=0接口：" + "/api/v1/Dictionaries/selectDictionaries")
    }
  } catch (e) {
    reject(e)
    console.log("字典接口catch接口：" + "/api/v1/Dictionaries/selectDictionaries" + e)
  }
}

/*根据key获取对应字典的文字,返回promise*/
/*dic_code查询字段要用的字典项名称，dic_key具体的字典key值*/
let get_name_by_key_promise = (dic_key, dic_code) => {
  return get_dictionaries(dic_code).then(res => {
    let item = res.data.find(item => {
      return item.code == dic_key
    })
    return item ? item.name : ''
  })
}


/*根据key获取对应字典的文字*/
let get_name_by_key = (row,key,dic_code) => {
  if(!row[key]){
    row[key+ '_name'] =  ''
    return
  }
  get_dictionaries(dic_code).then(res =>{
    let item = res.data.find(item => {return item.code == row[key]})
    if(item){
      row[key+ '_name'] = item.name || ''
    }
  })

}

/*根据key获取对应字典的文字*/
let get_key_by_name = (name,dic_code) => {
  return new Promise((resolve,reject) =>{
    if(!name){
      resolve ("");
    }
    get_dictionaries(dic_code).then(res =>{
      let item = res.data.find(item => {return item.name == name})
      resolve (item.code);
    })
  });

}

export default {
  get_dictionaries,/*查询字典表*/
  get_name_by_key,/*根据key获取对应字典的文字*/
  get_name_by_key_promise,/*根据key获取对应字典的文字,返回Promise*/
  get_key_by_name,/*根据对应字典的文字获取key -jh*/
  get_name_by_key_new/*根据key获取对应字典的文字*/
}



// WEBPACK FOOTER //
// ./src/assets/js/global_tool/sys_tool/get_administrator_dictionaries_data.js